<template>
  <v-card class="card--shadow">
    <v-card-title class="purple accent-4">
      <div class="subtitle-1 white--text">Township Form</div>
    </v-card-title>
    <v-card-text class="pt-4">
      <form-require-noti />
      <label>Name <require-sign /> </label>
      <v-text-field
        v-model.trim="township.name"
        :error-messages="handleFieldErrors($v.township.name)"
        type="text"
        outlined
        dense
      ></v-text-field>

      <label>Short Code <require-sign /> </label>
      <v-text-field
        v-model.trim="township.short_code"
        :error-messages="handleFieldErrors($v.township.short_code)"
        type="text"
        outlined
        dense
      ></v-text-field>
      <label>Township Group <require-sign /> </label>
      <v-combobox
        v-model="township.township_group"
        :error-messages="handleFieldErrors($v.township.township_group)"
        outlined
        dense
        item-text="name"
        item-value="id"
        :items="townshipGroups"
      ></v-combobox>
      <label>Region <require-sign /></label>
      <v-combobox
        v-model="township.region"
        :error-messages="handleFieldErrors($v.township.region)"
        outlined
        dense
        item-text="name"
        item-value="id"
        :items="regions"
      ></v-combobox>
      <label>Initial <require-sign /></label>
      <v-select
        :items="initalOpt"
        v-model="township.initial"
        item-text="name"
        item-value="id"
        dense
        outlined
      ></v-select>
      <label>Both MDR and PICTS <require-sign /></label>
      <v-select
        :items="initialPj"
        v-model="township.both_mdr_picts"
        item-text="name"
        item-value="id"
        dense
        outlined
      ></v-select>
    </v-card-text>

    <v-card-actions class="px-4 pb-4">
      <v-spacer></v-spacer>
      <v-btn v-if="township.id" @click="emitTownshipData" class="form-btn"
        >Update</v-btn
      >
      <v-btn v-else @click.prevent="emitTownshipData" class="form-btn"
        >Submit</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { ValidationMixin } from "./../../mixins/ValidationMixin";
import { mapState } from "vuex";
import FormRequireNoti from "@/components/notification/FormRequireNoti.vue";
import RequireSign from "@/components/notification/RequireSign.vue";

export default {
  mixins: [ValidationMixin],
  props: {
    township: {
      type: Object,
      default: () => {
        return {
          name: null,
          short_code: null,
          township_group: null,
          region: null,
          initial: 1,
          both_mdr_picts: 1,
        };
      },
    },
    roles: {
      type: Array,
    },
  },
  components: {
    FormRequireNoti,
    RequireSign,
  },
  data: () => ({}),
  validations: {
    township: {
      name: {
        required,
      },
      short_code: {
        required,
      },
      township_group: {
        required,
      },
      region: {
        required,
      },
    },
  },
  computed: {
    ...mapState("Loading", ["loading"]),
    ...mapState("TownshipGroup", ["townshipGroups"]),
    ...mapState("Region", ["regions"]),
    ...mapState("Township", ["initalOpt", "initialPj"]),
  },
  watch: {
    admin() {
      if (this.admin.role) {
        this.admin.role = this.roles.find((item) => {
          return item.id == this.admin.role;
        });
        console.log(this.admin.role);
      }
    },
  },
  methods: {
    emitTownshipData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let data = {
          name: this.township.name,
          short_code: this.township.short_code,
          township_group_id: this.township.township_group.id,
          region_id: this.township.region.id,
          initial: this.township.initial,
          both_mdr_picts: this.township.both_mdr_picts,
        };

        this.township.id ? (data.id = this.township.id) : false;

        this.$emit("emitTownshipData", data);

        this.township.name = null;
        this.township.short_code = null;
        this.township.township_group = null;
        this.township.region = null;
        this.$v.$reset();
      }
    },
  },
  created() {
    this.$store.dispatch("TownshipGroup/getTownshipGroups");

    this.$store.dispatch("Region/getRegions");
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
